export const getNextTempJobId = async () => `TEMP-${Date.now()}`;
export const getNextConvertedJobId = async () => `HD-${Date.now()}`;